/**
 * Custom hook for Mutu Buah data management
 */

import { useState, useEffect, useCallback } from 'react';
import { MutuBuahData, MutuBuahFilters, PenaltyRate } from '../types';
import MutuBuahApiService from '../services/mutuBuahApiService';

export const useMutuBuah = () => {
  const [data, setData] = useState<MutuBuahData[]>([]);
  const [penaltyRates, setPenaltyRates] = useState<PenaltyRate[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async (filters: MutuBuahFilters) => {
    if (!filters.estate_id || !filters.division_id || !filters.inspection_date) {
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const result = await MutuBuahApiService.getDetails(filters);
      setData(result.data);
      setPenaltyRates(result.penalty_rates);
    } catch (err: any) {
      setError(err.message || 'Failed to fetch data');
      setData([]);
      setPenaltyRates([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    data,
    penaltyRates,
    loading,
    error,
    fetchData,
  };
};

export default useMutuBuah;
